import moment from 'moment';

export function validaIntegracao(idLoteConjunto) {
  return idLoteConjunto > 0;
}

export function validaChildren(children) {
  return children !== null;
}

export function validaLimiteDisponivelEmbarcado(data_acao) {
  const periodo = moment().diff(moment(data_acao), 'hours');
  const tempoLimite = 48;
  return periodo <= tempoLimite;
}

export function validaDateToday(record, [, dataFiltro]) {
  if (!record.data_ultimo_checkin) {
    return false;
  }

  const isEmbarcado = record.status_lote_conjunto === 'Embarcado';

  const isFiltroToday =
    moment(dataFiltro).format('DD/MM/YYYY') === moment().format('DD/MM/YYYY');

  if (!isFiltroToday && !isEmbarcado) {
    return false;
  }

  const passouCincoDiasDesdeUltimoCheckin =
    moment()
      .startOf('day')
      .diff(moment(record.data_ultimo_checkin).startOf('day'), 'days') > 5;

  if (passouCincoDiasDesdeUltimoCheckin) {
    return false;
  }

  if (isEmbarcado) {
    return validaLimiteDisponivelEmbarcado(record.data_acao);
  }

  // abre a localização
  return true;
}
